import React from 'react';
import { titleize } from 'inflection';

import styles from './ideaViewsIdeaInfoStyles';

import IdeaReturnToDate from 'buyside/components/presentation/IdeaViewsPage/IdeaViewsIdeaInfo/IdeaReturnToDate/ideaReturnToDate';
import IdeaCommunityRating from 'buyside/components/presentation/IdeaCommunityRating/ideaCommunityRating';
import Link from 'buyside/components/presentation/Link/link';

import { formatDate } from 'buyside/util/dateHelper';
import { ideaUrl } from 'buyside/util/urlHelper';
import separateWithDots from 'buyside/util/separateWithDots';

const IdeaViewsIdeaInfo = ({ idea }) => {
  const showRating =
    idea.expectedPerformanceRating && idea.expectedPerformanceRating.userRatingCount > 3;
  const isDebtOrPreferred = idea.positions.every(
    position => position.asset.isCredit || position.asset.isPreferred
  );
  return (
    <div className={styles.ideaInfoWrap}>
      <div className={styles.ideaInfoSection}>
        <Link to={ideaUrl(idea.id)} className={styles.ideaInfoEntityName}>
          {idea.positions.map(position => (
            <div key={position.id}>{titleize(position.asset.entity.name)}</div>
          ))}
        </Link>
        {!!idea.totalReturn && (
          <IdeaReturnToDate
            style={styles.ideaInfoFigure}
            closedAt={idea.closedAt}
            totalReturn={idea.totalReturn}
            showHeader={false}
          />
        )}
        {showRating && (
          <IdeaCommunityRating
            style={styles.ideaInfoFigure}
            rating={idea.expectedPerformanceRating}
          />
        )}
      </div>
      <div className={styles.ideaInfoSection}>
        <div className={styles.ideaInfoItem}>
          Asset Class:{' '}
          <strong>
            {separateWithDots(idea.positions.map(position => position.asset.assetClassName))}
          </strong>
        </div>
        <div className={styles.ideaInfoItem}>
          {isDebtOrPreferred ? 'CUSIP: ' : 'Symbol: '}
          <strong>
            {separateWithDots(idea.positions.map(position => position.asset.primarySymbol))}
          </strong>
        </div>
        <div className={styles.ideaInfoItem}>
          Submitted: <strong>{formatDate(idea.openedAt)}</strong>
        </div>
        <div className={styles.ideaInfoItem}>
          Last Updated: <strong>{formatDate(idea.lastUpdatedAt)}</strong>
        </div>
      </div>
    </div>
  );
};

export default IdeaViewsIdeaInfo;
